import { useCallback, useEffect, useMemo, useState } from 'react'
import { supabase } from './supabase'

export const MAX_CHALLENGES = 3

// Sfide di una lega: elenco, e azioni (lancia, risponde, chiude). Le azioni rispondono { ok, error }.
export function useRivalries(leagueId, userId) {
  const [state, setState] = useState({ loading: true, error: false, rows: [] })
  const [tick, setTick] = useState(0)
  const reload = useCallback(() => setTick(n => n + 1), [])

  useEffect(() => {
    if (!leagueId) return
    let cancelled = false
    supabase.rpc('fn_rivalry_list', { p_id_league: leagueId }).then(({ data, error }) => {
      if (cancelled) return
      if (error) setState(s => ({ ...s, loading: false, error: true }))
      else setState({ loading: false, error: false, rows: data ?? [] })
    })
    return () => { cancelled = true }
  }, [leagueId, tick])

  const act = useCallback(async (fn, args) => {
    const { data, error } = await supabase.rpc(fn, args)
    reload()
    if (error) return { ok: false, error: 'generic' }
    return data ?? { ok: false, error: 'generic' }
  }, [reload])

  const derived = useMemo(() => {
    const rows = state.rows
    const involved = (r) => r.id_challenger === userId || r.id_rival === userId
    const other = (r) => (r.id_challenger === userId ? r.id_rival : r.id_challenger)
    const open = rows.filter(r => (r.status === 'pending' || r.status === 'active') && involved(r))
    return {
      incoming: rows.filter(r => r.status === 'pending' && r.id_rival === userId),
      outgoing: rows.filter(r => r.status === 'pending' && r.id_challenger === userId),
      active: rows.filter(r => r.status === 'active'),
      ended: rows.filter(r => r.status === 'ended'),
      used: rows.filter(r => r.id_challenger === userId && (r.status === 'pending' || r.status === 'active')).length,
      busyWith: new Set(open.map(other)),     // con chi sono gia' in sfida (o in attesa)
      involved, other,
    }
  }, [state.rows, userId])

  return {
    ...state, ...derived, reload,
    request: (target) => act('fn_rivalry_request', { p_id_league: leagueId, p_target: target }),
    respond: (id, accept) => act('fn_rivalry_respond', { p_id: id, p_accept: accept }),
    end: (id) => act('fn_rivalry_end', { p_id: id }),
  }
}
